import { createCachedSelector } from "re-reselect";

import type { MappedOperator } from "@busbud/int-schemas/udm";

import { FAKE_MULTIPLE_OPERATORS_ID } from "@app/helpers/departure-helpers/interconnection";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getSearchedLegSegments } from "./get-segments";
import { getTripsOperators } from "../state-accessors";

const getSearchedLegOperatorIds = createCachedSelector(
  [getSearchedLegSegments],
  segments => {
    return Array.from(
      new Set<string>(segments.map(segment => segment.operator_id))
    );
  }
)((_state, trip_id) => trip_id);

export const getSearchedLegOperators = createCachedSelector(
  [getTripsOperators, getSearchedLegOperatorIds],
  (
    trips_operators: ResultsReduxState["trips_operators"],
    operator_ids: string[]
  ) =>
    operator_ids.map<MappedOperator>(
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      operator_id => trips_operators[operator_id]
    )
)((_state, trip_id) => trip_id);

export const getDisplayOperator = createCachedSelector(
  [getSearchedLegOperators, getTripsOperators],
  (
    operators: Array<MappedOperator>,
    trips_operators: ResultsReduxState["trips_operators"]
  ) => {
    // Single operator, no interconnection
    if (operators.length === 1) {
      return operators[0];
    }

    // Interconnection but same operator all the way
    const are_same_operators = operators.every(
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      operator => operator.name === operators[0].name
    );

    if (are_same_operators) {
      return operators[0];
    }

    const fallback = {} as MappedOperator;

    // Multiple operators
    return trips_operators[FAKE_MULTIPLE_OPERATORS_ID] || fallback;
  }
)((_state, trip_id) => trip_id);

export const getTripOperators = createCachedSelector(
  [getSearchedLegOperators, getTripsOperators],
  (
    operators: Array<MappedOperator>,
    trips_operators: ResultsReduxState["trips_operators"]
  ) => {
    return operators.map(o => trips_operators[o.id]);
  }
)((_state, trip_id) => trip_id);
